import { useEffect } from "react";
import FieldGroup from "../../FieldGroup/FieldGroup";
import ColorPicker from "../../ColorPicker/ColorPicker";
import Checkbox from "../../Checkbox/Checkbox";
import { useContext } from "react";
import { ConfigurationContext, DispatchContext } from "./ConfigurationContext";
import { isCheckboxSelected } from "./utils";

const FormStepInteriorExterior = ({
  woodField,
  woodTreatmentField,
  linerColorField, linerTypeField, heaterField
}) => {
  const {
    heaters: { heater },
    interiorexterior: { wood, woodTreatment, linerColor, linerType },
  } = useContext(ConfigurationContext);
  const dispatch = useContext(DispatchContext);

  const handleWoodChange = (option) => {
    dispatch({ type: "SELECT_WOOD", payload: option });
  };

  const handleWoodTreatmentChange = (option, checked) => {
    dispatch({ type: "SELECT_WOOD_TREATMENT", payload: { option, checked } });
  };

  const handleLinerColorChange = (option) => {
    dispatch({ type: "SELECT_LINER_COLOR", payload: option });
  };

  const handleLinearTypeChange = (option) => {
        dispatch({ type: "SELECT_LINER_TYPE", payload: {option, heaters: heaterField.options} });
    };


    const woodGroupId = `${woodField.name}-radio-group`;
  const woodTreatmentGroupId = `${woodTreatmentField.name}-group`;
  const linerColorGroupId = `${linerColorField.name}-group`;
  const fieldLinerTypeGroupId = `${linerTypeField.name}-radio-group`;

  const isLinearTypeSelected = (option) => option.id === linerType?.id

  useEffect(() => {
    dispatch({ type: "SELECT_WOOD", payload: woodField.options[0] });
  }, [dispatch, woodField, linerColorField]);

    useEffect(() => {
        dispatch({
            type: "SELECT_LINER_COLOR",
            payload: linerColorField.options[0],
        });
    }, [dispatch, linerColorField]);

  return (
    <>
        <FieldGroup
            title={linerTypeField.title}
            id={fieldLinerTypeGroupId}
            details={linerTypeField.details}>
            {linerTypeField.options.map((option) => (
                <Checkbox
                    key={option.id}
                    type="radio"
                    name={fieldLinerTypeGroupId}
                    isChecked={isLinearTypeSelected(option)}
                    {...option}
                    onChange={handleLinearTypeChange}
                />
            ))}
        </FieldGroup>
        <FieldGroup title={linerColorField.title} id={linerColorGroupId}>
            <ColorPicker
                options={linerColorField.options}
                selectedOption={linerColor}
                onChange={handleLinerColorChange}
                fieldId={linerColorGroupId}
            />
        </FieldGroup>
      <FieldGroup
        title={woodField.title}
        id={woodGroupId}
        details={woodField.details}
      >
        <ColorPicker
          options={woodField.options}
          selectedOption={wood}
          onChange={handleWoodChange}
          fieldId={woodGroupId}
        />

        {woodTreatmentField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={woodTreatmentGroupId}
            isChecked={isCheckboxSelected(option, woodTreatment)}
            {...option}
            onChange={handleWoodTreatmentChange}
          />
        ))}
      </FieldGroup>
    </>
  );
};

export default FormStepInteriorExterior;
